import creators from '../data/creators.json';

export const THEMES = {
  すとぷり: {
    group: "すとぷり",
    logo: "/images/groups/stpr.webp",
    dark: false,
    panelOverlay: "rgba(255,96,143,0.25)",
    uiOverlay: "linear-gradient(180deg, rgba(255,220,230,0.70) 0%, rgba(255,240,220,0.75) 100%)",
    accent: "#FF608F",
    cardTint: "#ff60a0",
    accentGlow: "rgba(255,96,143,0.4)",
    buttonGradient: "linear-gradient(92deg, #FF608F 5%, #FBB35E 95%)",
    groupLabelColor: "#d63060",
    groupLabelGlow: "0 0 12px rgba(255,96,143,0.5)",
    cardBg: "rgba(255,255,255,0.72)",
    cardBorderColor: "#FF608F",
    cardText: "#1f2937",
    titleColor: "#be123c",
    subtitleColor: "#fb7185",
    countColor: "#fda4af",
  },
  騎士X: {
    group: "騎士X",
    logo: "/images/groups/knightx.webp",
    dark: true,
    panelOverlay: "rgba(8,12,48,0.30)",
    uiOverlay: "linear-gradient(180deg, rgba(8,12,48,0.72) 0%, rgba(4,6,24,0.82) 100%)",
    accent: "#BE8C4E",
    cardTint: "#c0c0c0",
    accentGlow: "rgba(190,140,78,0.5)",
    buttonGradient: "linear-gradient(90deg, #7a5a2e 0%, #BE8C4E 50%, #cca676 100%)",
    groupLabelColor: "#cca676",
    groupLabelGlow: "0 0 14px rgba(204,166,118,0.7)",
    cardBg: "rgba(20,21,23,0.65)",
    cardBorderColor: "#BE8C4E",
    cardText: "#f3f4f6",
    titleColor: "#fde68a",
    subtitleColor: "#cbd5e1",
    countColor: "#94a3b8",
  },
  "AMPTAK×COLORS": {
    group: "AMPTAK×COLORS",
    logo: "/images/groups/amptak.webp",
    dark: false,
    panelOverlay: "rgba(245,151,41,0.20)",
    uiOverlay: "linear-gradient(180deg, rgba(255,248,220,0.68) 0%, rgba(255,230,245,0.75) 100%)",
    accent: "#F59729",
    cardTint: "#ffffff",
    accentGlow: "rgba(245,151,41,0.45)",
    buttonGradient: "linear-gradient(90deg, #F59729 0%, #cc7aae 100%)",
    groupLabelColor: "#c06000",
    groupLabelGlow: "0 0 10px rgba(245,151,41,0.4)",
    cardBg: "rgba(255,255,255,0.70)",
    cardBorderColor: "#F59729",
    cardText: "#1f2937",
    titleColor: "#c2410c",
    subtitleColor: "#fb923c",
    countColor: "#fdba74",
  },
  めておら: {
    group: "めておら",
    logo: "/images/groups/meteorites.webp",
    dark: true,
    panelOverlay: "rgba(40,5,90,0.18)",
    uiOverlay: "linear-gradient(180deg, rgba(25,5,70,0.58) 0%, rgba(5,0,35,0.68) 100%)",
    accent: "#78dcff",
    cardTint: "#9966ff",
    accentGlow: "rgba(120,220,255,0.6)",
    buttonGradient: "linear-gradient(90deg, #3a007a 0%, #0057b3 50%, #78dcff 100%)",
    groupLabelColor: "#78dcff",
    groupLabelGlow: "0 0 20px rgba(120,220,255,1.0)",
    cardBg: "rgba(25,5,75,0.65)",
    cardBorderColor: "#78dcff",
    cardText: "#dbeafe",
    titleColor: "#a5f3fc",
    subtitleColor: "#d8b4fe",
    countColor: "#c084fc",
  },
  とぅるりぷ: {
    group: "とぅるりぷ",
    logo: "/images/groups/truelip.jpg",
    dark: true,
    panelOverlay: "rgba(160, 10, 30, 0.18)",
    uiOverlay: "linear-gradient(180deg, rgba(60,5,10,0.60) 0%, rgba(30,2,5,0.70) 100%)",
    accent: "#e63946",
    cardTint: "#bb1122",
    accentGlow: "rgba(220,20,60,0.55)",
    buttonGradient: "linear-gradient(90deg, #7b0d1e 0%, #e63946 50%, #c9a84c 100%)",
    groupLabelColor: "#f4a0a8",
    groupLabelGlow: "0 0 14px rgba(230,57,70,0.7)",
    cardBg: "rgba(30,5,8,0.65)",
    cardBorderColor: "#e63946",
    cardText: "#fde8ea",
    titleColor: "#fca5a5",
    subtitleColor: "#f4a0a8",
    countColor: "#f87171",
  },
  すにすて: {
    group: "すにすて",
    logo: "/images/groups/sneaker.webp",
    dark: false,
    panelOverlay: "rgba(220,10,10,0.15)",
    uiOverlay: "linear-gradient(180deg, rgba(255,255,255,0.78) 0%, rgba(245,240,240,0.82) 100%)",
    accent: "#ff6600",
    cardTint: "#ff8833",
    accentGlow: "rgba(255,102,0,0.5)",
    buttonGradient: "linear-gradient(90deg, #111111 0%, #ff6600 55%, #ffaa00 100%)",
    groupLabelColor: "#cc5500",
    groupLabelGlow: "0 0 12px rgba(255,102,0,0.5)",
    cardBg: "rgba(255,255,255,0.82)",
    cardBorderColor: "#ff6600",
    cardText: "#111827",
    titleColor: "#cc4400",
    subtitleColor: "#6b7280",
    countColor: "#9ca3af",
  },
};

export const DEFAULT_THEME = THEMES["すとぷり"];

export const STPR_TILE =
  "https://strawberryprince.stpr.com/assets/95a275d3-d9e1-4457-866a-7cbbb5fd8970/_next/static/media/bg_kv_tile.b4913466.png";

export function getCreatorsByIds(ids) {
  return ids.map((id) => creators.find((c) => c.id === id)).filter(Boolean);
}

export function getGroupTheme(creatorId) {
  const creator = creators.find((c) => c.id === creatorId);
  return creator ? (THEMES[creator.group] || DEFAULT_THEME) : DEFAULT_THEME;
}
